"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncryptedBlobSchema = exports.PositiveMoneySchema = exports.MoneySchema = exports.CurrencySchema = exports.EnvCodeSchema = exports.OctopusIdSchema = void 0;
// Octopus API contracts use `zod/v4`: octopus validates and documents its routes with
// fastify-type-provider-zod, which needs v4 schemas. Do not mix in the classic-zod
// helpers from `schemas/common.ts` (NumericIdSchema, …).
const v4_1 = require("zod/v4");
exports.OctopusIdSchema = v4_1.z.number().int().positive();
/** Code of a country (child) database, e.g. 'cz', 'sk', 'en'. */
exports.EnvCodeSchema = v4_1.z.string().min(1);
exports.CurrencySchema = v4_1.z.string().regex(/^[A-Z]{3}$/, { message: 'Must be 3 capital letters, e.g. CZK' });
// Money travels as decimal strings ("1290.00"), never numbers, so no amount passes through a float.
// DECIMAL(12, 2): at most 10 digits before the point.
const MONEY_PATTERN = /^\d{1,10}(?:\.\d{1,2})?$/;
exports.MoneySchema = v4_1.z
    .string()
    .regex(MONEY_PATTERN, { message: 'Must be a decimal string with up to 2 decimals' });
exports.PositiveMoneySchema = exports.MoneySchema.refine((value) => /[1-9]/.test(value), { message: 'Must be above 0' });
exports.EncryptedBlobSchema = v4_1.z.object({
    cryptoMethod: v4_1.z.string().min(1).max(64),
    iv: v4_1.z.string().min(1),
    cipherText: v4_1.z.string().min(1),
});
